(function () {

  if (window.__DL_CART_DRAWER_INIT__) return;

  window.__DL_CART_DRAWER_INIT__ = true;



  /* ── API endpoints (locale-aware) ── */

  const getRouteRoot = () => {

    try { return window.Shopify?.routes?.root || window.routes?.root || "/"; } catch {}

    return "/";

  };



  const apiUrl = (path) => getRouteRoot() + path;



  /* ── Shared state ── */

  const STATE = {

    pending: false,

    intent: null,

    intentUntil: 0,

    warrantyVariantId: 0,

    warrantyKey: "",

    handleCache: {},

    lastCart: null,

    debounceT: null,

    upsellSig: "",

    upsellCache: {},

    rendering: false,

  };



  /* ── Helpers ── */

  const locale = document.documentElement.lang === "en" ? "en-GB" : "fr-FR";



  const getShopCurrency = () => {

    try { return Shopify.currency?.active || window.theme?.currency || "EUR"; } catch {}

    return "EUR";

  };



  const moneyFormat = (cents, currency) => {

    const cur = currency || getShopCurrency();

    try {

      return new Intl.NumberFormat(locale, { style: "currency", currency: cur }).format((cents || 0) / 100);

    } catch {

      return ((cents || 0) / 100).toFixed(2) + " " + cur;

    }

  };



  const fetchCart = async () => {

    const r = await fetch(apiUrl("cart.js"), { credentials: "same-origin" });

    return r.json();

  };



  const postJson = async (url, payload) => {

    return fetch(url, {

      method: "POST",

      headers: { "Content-Type": "application/json" },

      credentials: "same-origin",

      body: JSON.stringify(payload),

    });

  };



  /* ── Render cart items ourselves from /cart.js data ── */

  const renderCartItems = (cart) => {

    const root = $productsRoot();

    if (!root) return;



    const wid = STATE.warrantyVariantId;

    const items = (cart?.items || []).filter((i) => !wid || i.variant_id !== wid);



    if (!items.length) {

      root.innerHTML = "";

      return;

    }



    root.innerHTML = "";



    items.forEach((item) => {

      const row = document.createElement("div");

      row.className = "dl-cart-item";

      row.dataset.key = item.key;



      /* Image */

      const imgWrap = document.createElement("a");

      imgWrap.href = item.url || "#";

      imgWrap.className = "dl-cart-item__img-wrap";



      const img = document.createElement("img");

      img.className = "dl-cart-item__img";

      img.alt = item.product_title || "";

      img.loading = "lazy";

      img.src = item.image

        ? item.image.replace(/(\.[^.]+)$/, "_180x$1")

        : item.featured_image?.url || "";

      imgWrap.appendChild(img);



      /* Title: spans full width (grid col 2-3) */

      const title = document.createElement("a");

      title.href = item.url || "#";

      title.className = "dl-cart-item__title";

      title.textContent = item.product_title || "";



      /* Info bottom: variant + qty (grid col 2) */

      const infoBottom = document.createElement("div");

      infoBottom.className = "dl-cart-item__info-bottom";



      /* Variant / options */

      if (item.variant_title) {

        const variant = document.createElement("div");

        variant.className = "dl-cart-item__variant";

        variant.textContent = item.variant_title;

        infoBottom.appendChild(variant);

      } else if (item.options_with_values?.length) {

        item.options_with_values.forEach((opt) => {

          if (opt.value === "Default Title") return;

          const line = document.createElement("div");

          line.className = "dl-cart-item__variant";

          line.textContent = `${opt.name}: ${opt.value}`;

          infoBottom.appendChild(line);

        });

      }



      /* Properties (ex: personnalisation) */

      if (item.properties) {

        Object.entries(item.properties).forEach(([k, v]) => {

          if (!v || k.charAt(0) === "_") return;

          const prop = document.createElement("div");

          prop.className = "dl-cart-item__variant";

          prop.textContent = `${k}: ${v}`;

          infoBottom.appendChild(prop);

        });

      }



      /* Quantity selector */

      const qtyWrap = document.createElement("div");

      qtyWrap.className = "dl-cart-item__qty";



      const btnMinus = document.createElement("button");

      btnMinus.type = "button";

      btnMinus.className = "dl-cart-item__qty-btn";

      btnMinus.textContent = "−";

      btnMinus.setAttribute("aria-label", "Diminuer");



      const qtyVal = document.createElement("span");

      qtyVal.className = "dl-cart-item__qty-val";

      qtyVal.textContent = String(item.quantity);



      const btnPlus = document.createElement("button");

      btnPlus.type = "button";

      btnPlus.className = "dl-cart-item__qty-btn";

      btnPlus.textContent = "+";

      btnPlus.setAttribute("aria-label", "Augmenter");



      /* Qty handlers */

      const changeQty = async (newQty) => {

        btnMinus.disabled = true;

        btnPlus.disabled = true;

        qtyWrap.classList.add("is-loading");



        try {

          await postJson(apiUrl("cart/change.js"), { id: item.key, quantity: Math.max(0, newQty) });

          const updated = await fetchCart();

          STATE.lastCart = updated;

          fullRender(updated);

        } catch {

          qtyWrap.classList.remove("is-loading");

          btnMinus.disabled = false;

          btnPlus.disabled = false;

        }

      };



      btnMinus.addEventListener("click", () => changeQty(item.quantity - 1));

      btnPlus.addEventListener("click", () => changeQty(item.quantity + 1));



      qtyWrap.appendChild(btnMinus);

      qtyWrap.appendChild(qtyVal);

      qtyWrap.appendChild(btnPlus);



      infoBottom.appendChild(qtyWrap);



        /* Price */

      const price = document.createElement("div");

      price.className = "dl-cart-item__price";

      price.textContent = moneyFormat(item.final_line_price || 0);



      if (item.original_line_price && item.original_line_price > item.final_line_price) {

        price.innerHTML = `<s class="dl-cart-item__compare">${moneyFormat(item.original_line_price)}</s> ${moneyFormat(item.final_line_price)}`;

      }



      /* Fetch compare_at_price from product data */

      (async () => {

        try {

          const root = getRouteRoot();

          const handle = (item.handle || item.url?.split("/products/")[1]?.split("?")[0] || "").trim();

          if (!handle) return;

          const cacheKey = root + handle;

          if (!STATE.handleCache["_product_" + cacheKey]) {

            const r = await fetch(`${root}products/${handle}.js`, { credentials: "same-origin" });

            if (r.ok) STATE.handleCache["_product_" + cacheKey] = await r.json();

          }

          const product = STATE.handleCache["_product_" + cacheKey];

          if (!product) return;

          const variant = product.variants?.find(v => v.id === item.variant_id);

          if (variant?.compare_at_price && variant.compare_at_price > variant.price) {

                        const compareTotal = Math.round(variant.compare_at_price * item.quantity);



            price.innerHTML = `<s class="dl-cart-item__compare">${moneyFormat(compareTotal)}</s> ${moneyFormat(item.final_line_price)}`;

          }

        } catch {}

      })();



      /* Assemble grid row */

      row.appendChild(imgWrap);

      row.appendChild(title);

      row.appendChild(infoBottom);

      row.appendChild(price);



      root.appendChild(row);

    });

  };



  /* ── Full render: update all sections at once ── */

  const fullRender = (cart) => {

    STATE.rendering = true;

    renderCartItems(cart);

    updateSubtotalUI(cart);

    updateDiscountsUI(cart);

    setProgressUI(cart);

    syncEmptyMidCTA(cart);

    syncWarrantyFromCart(cart);

    hideWarrantyLineInDOM();

    renderUpsell(cart);

    /* Release guard after DOM settles */

    requestAnimationFrame(() => { STATE.rendering = false; });

  };



  /* ── Discounts display ── */

  const updateDiscountsUI = (cart) => {

    const el = document.querySelector("#CartDrawer [data-discounts]");

    if (!el) return;



    const discounts = cart?.cart_level_discount_applications || [];

    if (!discounts.length) {

      el.innerHTML = "";

      return;

    }



    const rows = discounts.map((d) =>

      `<div class="cart__discount">${d.title} (-${moneyFormat(d.total_allocated_amount)})</div>`

    ).join("");



    el.innerHTML = `

      <div class="cart__discounts cart__item-sub cart__item-row">

        <div>${document.documentElement.lang === "en" ? "Discounts" : "Réductions"}</div>

        <div class="text-right">${rows}</div>

      </div>`;

  };



  const fetchVariantIdFromHandle = async (handle) => {

    if (!handle) return 0;

    if (STATE.handleCache[handle]) return STATE.handleCache[handle];

    const root = getRouteRoot();

    const r = await fetch(`${root}products/${handle}.js`, { credentials: "same-origin" });

    if (!r.ok) return 0;

    const p = await r.json();

    const id = p?.variants?.[0]?.id ? parseInt(p.variants[0].id, 10) : 0;

    STATE.handleCache[handle] = id;

    return id;

  };



  const cartFindWarranty = (cart, variantId) => {

    if (!variantId || !cart?.items) return { inCart: false, key: "" };

    for (const item of cart.items) {

      if (item?.variant_id === variantId) return { inCart: true, key: item.key };

    }

    return { inCart: false, key: "" };

  };



  /* ── DOM selectors ── */

  const $ = (sel) => document.querySelector(`#CartDrawer ${sel}`);



  const $wrap         = () => $("[data-dl-warranty]");

  const $toggle       = () => $wrap()?.querySelector("[data-dl-warranty-toggle]") || null;

  const getWarrantyHandle = () => ($wrap()?.dataset?.handle || "").trim();



  const $progressRoot = () => $("[data-dl-cart-progress]");

  const $productsRoot = () => $("[data-products]");

  const $emptyMid     = () => $("[data-dl-empty-mid]");

  const $subtotal     = () => $("[data-subtotal]");

  const $inner        = () => $("[data-cart-inner]");

  const $nativeEmpty  = () => $("[data-cart-empty]");

  const $upsell       = () => $("[data-dl-upsell]");

  const $upsellTrack  = () => $("[data-dl-upsell-track]");



  const isIntentActive = () => STATE.intent !== null && Date.now() < STATE.intentUntil;



  /* ── Warranty UI helpers ── */

  const setPendingUI = (pending) => {

    const w = $wrap();

    const t = $toggle();

    if (t) t.disabled = !!pending;

    if (w) w.classList.toggle("is-loading", !!pending);

  };



  const setToggleCheckedSilently = (checked) => {

    const t = $toggle();

    if (!t) return;

    t.dataset.lock = "1";

    t.checked = !!checked;

    setTimeout(() => { delete t.dataset.lock; }, 0);

  };



  /* ── Subtotal ── */

  const updateSubtotalUI = (cart) => {

    const el = $subtotal();

    if (!el) return;

    el.textContent = moneyFormat(cart?.total_price || 0);

  };



  /* ── Real items count (excl. warranty) ── */

  const countRealItemsQty = (cart) => {

    const wid = STATE.warrantyVariantId;

    return (cart?.items || []).reduce((acc, item) => {

      if (wid && item.variant_id === wid) return acc;

      return acc + (item.quantity || 0);

    }, 0);

  };



  /* ── Empty state sync ── */

  const syncEmptyMidCTA = (cart) => {

    const emptyMid    = $emptyMid();

    const productsRoot = $productsRoot();

    const inner       = $inner();

    const nativeEmpty = $nativeEmpty();



    const isEmpty = countRealItemsQty(cart) === 0;



    if (inner)       inner.style.display = "block";

    if (nativeEmpty) nativeEmpty.style.display = "none";

    if (emptyMid)    emptyMid.classList.toggle("hide", !isEmpty);

    if (productsRoot) productsRoot.classList.toggle("hide", isEmpty);



    const pr = $progressRoot();

    if (pr) pr.style.display = isEmpty ? "none" : "";

  };



  /* ── Progress bar ── */

  const setProgressUI = (cart) => {

    const root = $progressRoot();

    if (!root) return;



    const mode            = root.dataset.mode || "amount";

    const thresholdAmount = parseInt(root.dataset.thresholdAmount || "8000", 10);

    const thresholdQty    = parseInt(root.dataset.thresholdQty || "2", 10);

    const textEl          = root.querySelector("[data-dl-cart-progress-text]");

    const fillEl          = root.querySelector("[data-dl-cart-progress-fill]");



    const tplRemaining = (root.dataset.textRemaining || "").trim()

      || (mode === "qty"

        ? "Encore {{qty}} article(s) pour livraison gratuite"

        : "Encore {{amount}} pour livraison gratuite");



    const tplReached = (root.dataset.textReached || "").trim()

      || "Livraison gratuite 🎉";



    const wid   = STATE.warrantyVariantId;

    const items = (cart?.items || []).filter((i) => !wid || i.variant_id !== wid);



    let current, threshold, msg;



    if (mode === "qty") {

      current   = items.reduce((s, i) => s + (i.quantity || 0), 0);

      threshold = Math.max(1, thresholdQty);

      const remaining = Math.max(0, threshold - current);

      msg = remaining > 0

        ? tplRemaining.replaceAll("{{qty}}", String(remaining))

        : tplReached;

    } else {

      current   = items.reduce((s, i) => s + (i.final_line_price || 0), 0);

      threshold = Math.max(1, thresholdAmount);

      const remaining = Math.max(0, threshold - current);

      msg = remaining > 0

        ? tplRemaining.replaceAll("{{amount}}", moneyFormat(remaining))

        : tplReached;

    }



    const pct = Math.max(0, Math.min(100, Math.round((current / threshold) * 100)));

    if (fillEl) fillEl.style.width = pct + "%";

    if (textEl) textEl.textContent = msg;

  };



  /* ── Hide warranty line in product list ── */

  const hideWarrantyLineInDOM = () => {

    if (!STATE.warrantyKey) return;

    const root = $productsRoot();

    if (!root) return;



    const escaped = CSS.escape(STATE.warrantyKey);

    const el = root.querySelector(`[data-key="${escaped}"]`)

            || root.querySelector(`[data-line-item-key="${escaped}"]`);

    if (el) el.style.display = "none";

  };



  /* ── Warranty init ── */

  const ensureWarrantyIds = async () => {

    const handle = getWarrantyHandle();

    if (!handle) return 0;

    STATE.warrantyVariantId = await fetchVariantIdFromHandle(handle);

    return STATE.warrantyVariantId;

  };



  const syncWarrantyFromCart = (cart) => {

    if (STATE.pending) return;

    const t = $toggle();

    if (!t) return;



    const found = cartFindWarranty(cart, STATE.warrantyVariantId);

    STATE.warrantyKey = found.key || "";



    if (isIntentActive()) {

      if (found.inCart === STATE.intent) {

        STATE.intent = null;

        STATE.intentUntil = 0;

      } else {

        hideWarrantyLineInDOM();

        return;

      }

    }



    setToggleCheckedSilently(found.inCart);

    hideWarrantyLineInDOM();

  };



  const addWarranty    = async () => postJson(apiUrl("cart/add.js"), { id: STATE.warrantyVariantId, quantity: 1 });

  const removeWarranty = async () => {

    if (!STATE.warrantyKey) {

      const cart  = await fetchCart();

      const found = cartFindWarranty(cart, STATE.warrantyVariantId);

      STATE.warrantyKey = found.key || "";

      if (!found.inCart) return;

    }

    await postJson(apiUrl("cart/change.js"), { id: STATE.warrantyKey, quantity: 0 });

  };



  /* ── Warranty toggle handler ── */

  const handleToggle = async (checked) => {

    if (STATE.pending || !STATE.warrantyVariantId) return;



    STATE.intent      = !!checked;

    STATE.intentUntil = Date.now() + 1200;

    STATE.pending     = true;



    setPendingUI(true);

    setToggleCheckedSilently(checked);



    try {

      if (checked) await addWarranty();

      else         await removeWarranty();



      const updated  = await fetchCart();

      STATE.lastCart = updated;



      fullRender(updated);

    } catch {

      STATE.intent      = null;

      STATE.intentUntil = 0;



      if (STATE.lastCart) {

        fullRender(STATE.lastCart);

      }

    }



    STATE.pending = false;

    setPendingUI(false);

  };



  const bindWarranty = (cart) => {

    const t = $toggle();

    const w = $wrap();

    if (!w || !t) return;



    const found = cartFindWarranty(cart, STATE.warrantyVariantId);

    STATE.warrantyKey = found.key || "";



    /* Auto-add warranty once per session, only if cart has real products */

    const realQty = countRealItemsQty(cart);

    if (!found.inCart && realQty > 0 && !window.__DL_WARRANTY_DEFAULT_DONE__) {

      window.__DL_WARRANTY_DEFAULT_DONE__ = true;

      handleToggle(true);

      return;

    }



    syncWarrantyFromCart(cart);



    if (t.dataset.bound === "1") return;

    t.dataset.bound = "1";

    t.addEventListener("change", () => {

      if (t.dataset.lock === "1") return;

      handleToggle(!!t.checked);

    });

  };



  /* =========================================

     UPSELL

  ========================================= */



  const cartSignature = (cart) => {

    const wid = STATE.warrantyVariantId;

    const items = (cart?.items || [])

      .filter((i) => !wid || i.variant_id !== wid)

      .map((i) => `${i.product_id}:${i.variant_id}:${i.quantity}`)

      .sort()

      .join("|");

    return `${document.documentElement.lang || "fr"}::${items}`;

  };



  const fetchCollectionProducts = async (handle) => {

    if (!handle) return [];

    const root = getRouteRoot();

    const cacheKey = root + handle;

    if (STATE.upsellCache[cacheKey]) return STATE.upsellCache[cacheKey];



    const url = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=50`;

    const r   = await fetch(url, { credentials: "same-origin" });

    if (!r.ok) return [];



    const data     = await r.json();

    const products = Array.isArray(data?.products) ? data.products : [];

    STATE.upsellCache[cacheKey] = products;

    return products;

  };



  const pickUpsellProducts = (products, cart) => {

    const upsell = $upsell();

    if (!upsell) return [];



    const limit = parseInt(upsell.dataset.limit || "4", 10);

    const wid   = STATE.warrantyVariantId;



    const inCartProductIds = new Set(

      (cart?.items || []).filter((i) => !wid || i.variant_id !== wid).map((i) => i.product_id)

    );



    const eligible = products.filter((p) => !inCartProductIds.has(p.id) && p.available !== false);



    /* Stable pseudo-random shuffle seeded from cart signature */

    const sig = cartSignature(cart);

    let seed  = 0;

    for (let i = 0; i < sig.length; i++) seed = (seed * 31 + sig.charCodeAt(i)) >>> 0;

    const rand = () => {

      seed ^= seed << 13; seed >>>= 0;

      seed ^= seed >> 17; seed >>>= 0;

      seed ^= seed << 5;  seed >>>= 0;

      return (seed >>> 0) / 4294967296;

    };



    return eligible.slice().sort(() => rand() - 0.5).slice(0, Math.max(0, limit));

  };



  const buildVariantSelect = (product) => {

    const optionNames = (product?.options || []).map((o) => (o?.name || "").toLowerCase());

    let optIndex = optionNames.findIndex((n) => n.includes("couleur") || n.includes("color"));

    if (optIndex < 0) optIndex = 0;



    const select  = document.createElement("select");

    select.className = "dl-upsell-select";

    select.setAttribute("aria-label", "Variant");



    (product?.variants || []).filter((v) => v.available !== false).forEach((v) => {

      const label = Array.isArray(v.options) ? (v.options[optIndex] || v.title) : v.title;

      const opt   = document.createElement("option");

      opt.value       = String(v.id);

      opt.textContent = label;

      select.appendChild(opt);

    });



    return select;

  };



  /* ── Arrows: created once inside existing .wrap ── */

  const ensureUpsellArrows = () => {

    const wrap  = $upsell()?.querySelector(".dl-cart-upsell__wrap");

    const track = $upsellTrack();

    if (!wrap || !track) return;

    if (wrap.dataset.arrowsBound === "1") return;

    wrap.dataset.arrowsBound = "1";



    const makeArrow = (dir, label, text) => {

      const btn       = document.createElement("button");

      btn.type        = "button";

      btn.className   = `dl-upsell-arrow dl-upsell-arrow--${dir}`;

      btn.setAttribute("aria-label", label);

      btn.textContent = text;

      wrap.appendChild(btn);

      return btn;

    };



    const left  = makeArrow("left",  "Précédent", "‹");

    const right = makeArrow("right", "Suivant",   "›");



    const getStep = () => {

      const card = track.querySelector(".dl-upsell-card");

      return card ? Math.round(card.getBoundingClientRect().width + card.offsetLeft * 2 / Math.max(1, track.children.length)) : 240;

    };



    const scrollToCard = (index) => {

      const cards = track.querySelectorAll(".dl-upsell-card");

      if (!cards.length) return;

      const clamped = ((index % cards.length) + cards.length) % cards.length;

      cards[clamped].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });

    };



    let currentIndex = 0;



    /* Reset index when cards change */

    const resetIndex = () => { currentIndex = 0; };

    wrap.resetArrowIndex = resetIndex;



    left.addEventListener("click", () => {

      const total = track.querySelectorAll(".dl-upsell-card").length;

      currentIndex = ((currentIndex - 1) + total) % total;

      scrollToCard(currentIndex);

    });



    right.addEventListener("click", () => {

      const total = track.querySelectorAll(".dl-upsell-card").length;

      currentIndex = (currentIndex + 1) % total;

      scrollToCard(currentIndex);

    });



    const refreshArrows = () => {

      const cards = track.querySelectorAll(".dl-upsell-card");

      const canScroll = cards.length > 1;

      left.style.display  = canScroll ? "" : "none";

      right.style.display = canScroll ? "" : "none";

      left.style.opacity  = "";

      right.style.opacity = "";

      left.disabled  = false;

      right.disabled = false;

    };



    track.addEventListener("scroll", () => requestAnimationFrame(refreshArrows));

    window.addEventListener("resize", () => requestAnimationFrame(refreshArrows));

    requestAnimationFrame(refreshArrows);

  };



  /* ── Render upsell cards ── */

  const renderUpsell = async (cart) => {

    const upsell = $upsell();

    const track  = $upsellTrack();

    if (!upsell || !track) return;



    const realQty = countRealItemsQty(cart);

    if (realQty <= 0) {

      upsell.classList.add("hide");

      track.innerHTML = "";

      STATE.upsellSig = "";

      return;

    }



    const sig = cartSignature(cart);

    if (STATE.upsellSig === sig) { ensureUpsellArrows(); return; }

    STATE.upsellSig = sig;



    const collectionHandle = (upsell.dataset.collection || "").trim();

    if (!collectionHandle) { upsell.classList.add("hide"); track.innerHTML = ""; return; }



    const products = await fetchCollectionProducts(collectionHandle);

    const picks    = pickUpsellProducts(products, cart);



    if (!picks.length) { upsell.classList.add("hide"); track.innerHTML = ""; return; }



    upsell.classList.remove("hide");

    track.innerHTML = "";



    picks.forEach((p) => {

      const card = document.createElement("div");

      card.className = "dl-upsell-card";



      const imgSrc = p?.images?.[0]?.src || p?.image?.src || "";

      const title  = p?.title || "";

      const price  = p?.variants?.[0]?.price

        ? moneyFormat(Math.round(parseFloat(p.variants[0].price) * 100))

        : "";



      /* Top: image + meta */

      const top  = document.createElement("div");

      top.className = "dl-upsell-top";



      const img  = document.createElement("img");

      img.className = "dl-upsell-img";

      img.alt     = title;

      img.loading = "lazy";

      if (imgSrc) img.src = imgSrc;



      const meta = document.createElement("div");

      meta.className = "dl-upsell-meta";



      const nameEl  = document.createElement("div");

      nameEl.className   = "dl-upsell-title";

      nameEl.textContent = title;



      const priceEl  = document.createElement("div");

      priceEl.className   = "dl-upsell-price";

      priceEl.textContent = price;



      meta.appendChild(nameEl);

      meta.appendChild(priceEl);

      top.appendChild(img);

      top.appendChild(meta);



      /* Actions: select + button */

      const actions = document.createElement("div");

      actions.className = "dl-upsell-actions";



      const select = buildVariantSelect(p);



      const btn       = document.createElement("button");

      btn.type        = "button";

      btn.className   = "dl-upsell-btn";

      btn.textContent = (upsell.dataset.cta || "Ajouter").trim();



      btn.addEventListener("click", async () => {

        const variantId = parseInt(select.value || "0", 10);

        if (!variantId) return;



        btn.disabled = true;

        btn.classList.add("is-loading");



        try {

          await postJson(apiUrl("cart/add.js"), { id: variantId, quantity: 1 });

          const updated  = await fetchCart();

          STATE.lastCart = updated;



          fullRender(updated);

        } finally {

          btn.disabled = false;

          btn.classList.remove("is-loading");

        }

      });



      actions.appendChild(select);

      actions.appendChild(btn);



      card.appendChild(top);

      card.appendChild(actions);

      track.appendChild(card);

    });



    ensureUpsellArrows();

    /* Reset carousel to first card */

    const wrap = $upsell()?.querySelector(".dl-cart-upsell__wrap");

    if (wrap?.resetArrowIndex) wrap.resetArrowIndex();

  };



  /* =========================================

     INIT

  ========================================= */

  const init = async () => {

    if (!document.getElementById("CartDrawer")) return;



    await ensureWarrantyIds();



    const cart     = await fetchCart();

    STATE.lastCart = cart;



    fullRender(cart);

    bindWarranty(cart);


  };



  const scheduleInit = () => {

    clearTimeout(STATE.debounceT);

    STATE.debounceT = setTimeout(() => {

      if (isIntentActive()) return;

      if (!STATE.pending) {

        init();

      } else if (STATE.lastCart) {

        fullRender(STATE.lastCart);

      }

    }, 150);

  };



  init();

  document.addEventListener("DOMContentLoaded", init);



  const drawer = document.getElementById("CartDrawer");

  if (drawer) {

    const obs = new MutationObserver(() => {

      if (STATE.rendering) return;

      scheduleInit();

    });

    obs.observe(drawer, { childList: true, subtree: true });



    /* Hide Heichat bubble when drawer is open */

    const hideChat = () => {

      const style = getComputedStyle(drawer);

      const isOpen = drawer.classList.contains("is-open") ||

                     drawer.classList.contains("drawer--open") ||

                     drawer.classList.contains("active") ||

                     (style.visibility === "visible" && drawer.offsetWidth > 0);



      document.querySelectorAll("heichat-launcher-shell").forEach((el) => {

        el.style.setProperty("display", isOpen ? "none" : "", "important");

      });

    };



    new MutationObserver(hideChat).observe(drawer, {

      attributes: true,

      attributeFilter: ["class", "style"],

    });

    setInterval(hideChat, 500);

  }

})();